import { coreApi } from '../../utils/axios';
import { CreateMasterMedicineResponse, GetMasterMedicineResponse, GetMasterMedicinesResponse, MasterMedicine } from './types';

export const getMasterMedicines = (page: number, limit: number) => {
  return coreApi.get<GetMasterMedicinesResponse>(`/master-medicines?page=${page}&limit=${limit}`);
};

export const updateMasterMedicine = (id: string, data: Partial<MasterMedicine>) => {
  return coreApi.put(`/master-medicines/${id}`, data);
};

export const getMasterMedicine = (id: string) => {
  return coreApi.get<GetMasterMedicineResponse>(`/master-medicines/${id}`);
};

export const createMasterMedicine = (data: Partial<MasterMedicine>) => {
  return coreApi.post<CreateMasterMedicineResponse>('/master-medicines', data);
}

export const deleteMasterMedicine = (id: string) => {
  return coreApi.delete(`/master-medicines/${id}`);
}